import type { CSSProperties } from "react";

import { useCommunitySwitcherSidebarItem } from "../hooks/useCommunitySwitcherSidebarItem";
import type { CommunitySwitcher } from "../types/CommunitySwitcher";
import { CommunitySectionPresentation } from "./CommunitySectionPresentation";

export interface CommunitySectionProps {
  readonly community: CommunitySwitcher;
  readonly hotkeyPosition?: number;
  readonly clickedCommunityId?: number | null;
  readonly dragHandleRef?: (element: Element | null) => void;
  readonly dragHandleStyle?: CSSProperties;
}

export const CommunitySection = ({
  community,
  hotkeyPosition,
  clickedCommunityId,
  dragHandleRef,
  dragHandleStyle,
}: CommunitySectionProps) => {
  const {
    href,
    iconUrl,
    isActive,
    isElectron,
    notificationCount,
    onElectronActivate,
  } = useCommunitySwitcherSidebarItem(community, clickedCommunityId);

  return (
    <CommunitySectionPresentation
      communityId={community.id}
      href={href}
      hotkeyPosition={hotkeyPosition}
      iconUrl={iconUrl}
      isActive={isActive}
      isElectron={isElectron}
      name={community.name}
      notificationCount={notificationCount}
      onElectronActivate={onElectronActivate}
      tooltipLabel={community.name}
      brandColor={community.brand_color}
      lightBrandColor={community.light_brand_color}
      darkBrandColor={community.dark_brand_color}
      dragHandleRef={dragHandleRef}
      dragHandleStyle={dragHandleStyle}
    />
  );
};
